export const GET_PLANTS = 'Get_Plants';